const base = require('./base')
const purchaseAPI = {
  machineryList:base.base.PHPPath+'fissionshare/Machinery/titleList',                   //视频列表
  submitPurchase:base.base.PHPPath+'fissionshare/Purchase/purchase',
  login:base.base.PHPPath+'fissionshare/Login/woalogin',
}
module.exports={
  purchaseAPI:purchaseAPI
}


// WEBPACK FOOTER //
// ./src/api/purchase.js